import { SearchRepository } from '@aipb/gulliver/catalog/data-access';
import { SearchTab } from '@aipb/gulliver/catalog/model';
import { ErrorCardComponent } from '@aipb/gulliver/catalog/ui';
import { FrameRepository } from '@aipb/gulliver/frame/data-access';
import { SimpleCardComponent } from '@aipb/shared/ui/card';
import { InsideLoadingComponent } from '@aipb/shared/ui/loading';
import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TranslocoModule } from '@jsverse/transloco';
import { combineLatest, Observable } from 'rxjs';
import { ResultTabGroupComponent } from '../result-tab-group/result-tab-group.component';

interface ResultVM {
  activeTabIndex: number;
  loading: boolean;
  isMobile: boolean;
}

@Component({
  selector: 'cat-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    InsideLoadingComponent,
    ErrorCardComponent,
    TranslocoModule,
    SimpleCardComponent,
    ResultTabGroupComponent,
    MatCardModule
  ]
})
export class ResultComponent {
  @Input() items: SearchTab[] = [];

  frameRepository = inject(FrameRepository);
  private searchRepository = inject(SearchRepository);

  vm$: Observable<ResultVM> = combineLatest({
    activeTabIndex: this.searchRepository.activeTabIndex$,
    loading: this.searchRepository.loading$,
    isMobile: this.frameRepository.isMobile$
  });
}
